import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import ListUrineSample from "../../components/Sample/ListUrineSample";
import {getTestByType} from '../../Api/tests';
function UrineSamples() {
  const [data, setData] = useState([]);
  useEffect(()=>{
    getTestByType(2, setData);
  }, []);
  return (
    <div className="w-full h-full">
      <Header Section="Sample" />
      <div className="w-full h-full flex flex-col px-20 mt-10  mb-20">
        <div className="w-full flex space-x-5 border-b-2 pb-2">
          <Link to="/" className="font-Lato-Regular text-xl text-[#B7C933]">
            Home
          </Link>
          <p className="font-Lato-Regular text-xl text-[#B7C933]">|</p>
          <Link
            to="/Sample"
            className="font-Lato-Regular text-xl text-[#B7C933]"
          >
            Sample
          </Link>
          <p className="font-Lato-Regular text-xl pl-5">
            Collecting and transporting urine samples
          </p>
        </div>
        <div className="w-full mt-10">
          <h1 className="text-2xl font-Lato-Bold">
            Collecting and transporting urine samples
          </h1>
          <p className="font-Lato-Regular text-lg mt-4">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          </p>
        </div>
        <ListUrineSample Data={data} />
      </div>
      <Footer />
    </div>
  );
}

export default UrineSamples;
